import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import * as Middleware from "@middlewares/index";
import Cookie from "@helpers/Cookie";

const Page: React.FC = () => {
  const history = useHistory();

  const workshopTitle: string = useSelector(
    (state: any) => state.Main.Workshop.data.title
  );

  const [currentPlan, setCurrentPlan] = useState<number>();

  const onSubmitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    let ProgressAlert: any;

    if (currentPlan === 1) {
      try {
        await Middleware.Schedule.subscribeAll(+process.env.SCHEDULE_ID);
        await Middleware.Profile.setSubscribeStatus(true);

        Middleware.Ui.Alert.open("Process", {
          text: "Вы зарегистрированы на все вебинары",
          component: (c: any) => {
            ProgressAlert = c;
          },
        });

        ProgressAlert.setStatus("success");
        ProgressAlert.startTimer();
        history.push("/");
      } catch (Exception) {
        throw Exception;
      }
    } else if (currentPlan === 2) {
      history.push("/?anchor=schedule-anchor");
    } else {
      return;
    }

    Cookie.set("isShowedPagePlan2", "true", {
      expires: new Date("Mar 01 2025 18:00:00"),
    });
  };

  return (
    <div className="plan">
      <div className="plan__wrapper">
        <div className="plan__header">
          <h1 className="plan__title">Осталcя последний шаг!</h1>
          <div className="plan__description">
            <h2 className="plan__subtitle">
              Вы зарегистрировались на онлайн-выставку «
              <span className="text-uppercase">{workshopTitle}</span>», которая
              проходит на портале Profi.Travel с 7 по 28 апреля.
            </h2>
          </div>
        </div>
        <form action="" className="plan__form" onSubmit={onSubmitHandler}>
          <div
            className={`plan__radio ${
              currentPlan === 1 ? "plan__radio--active" : ""
            }`}
            key="1"
          >
            <input
              className="visually-hidden"
              type="radio"
              name="plan"
              id="all"
              onChange={() => {
                setCurrentPlan(1);
              }}
              checked={currentPlan === 1}
            />
            <label className="plan__radio-label" htmlFor="all">
              <div className="plan__radio-header">
                <div className="plan__radio-title">
                  Зарегистрироваться на{" "}
                  <span className="text-blue">все вебинары</span>
                </div>
              </div>
              <div className="plan__radio-desc">
                В течение трех недель запланированы вебинары от регионов,
                туроператоров, отельеров и других компаний, которые продают
                российский турпродукт. Вы можете автоматически
                зарегистрироваться на все вебинары, чтобы точно ничего не
                пропустить.
              </div>
            </label>
          </div>
          <div
            className={`plan__radio ${
              currentPlan === 2 ? "plan__radio--active" : ""
            }`}
            key="2"
          >
            <input
              className="visually-hidden"
              type="radio"
              name="plan"
              id="no-webinars"
              onChange={() => {
                setCurrentPlan(2);
              }}
              checked={currentPlan === 2}
            />
            <label className="plan__radio-label" htmlFor="no-webinars">
              <div className="plan__radio-header">
                <div className="plan__radio-title">
                  Составить <span className="text-blue">своё расписание</span>
                </div>
              </div>
              <div className="plan__radio-desc">
                а хотите учиться по индивидуальному расписанию — мы рекомендуем
                вам посмотреть расписание вебинаров и подписаться на те, которые
                вам интересны.
              </div>
            </label>
          </div>

          <button
            className={`btn btn--medium btn--blue-white ${
              currentPlan ? "" : "disabled"
            }`}
            type="submit"
          >
            Завершить регистрацию
          </button>
        </form>
      </div>
    </div>
  );
};

export default Page;
